// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dlp-panel {
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background: #ffffff;
  padding: 12px;
  max-height: 560px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}

.dlp-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.dlp-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.dlp-collapse-toggle {
  width: 32px;
  height: 32px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  color: #111827;
  cursor: pointer;
}

.dlp-collapse-toggle--collapsed {
  width: 100%;
  height: auto;
  padding: 10px 12px;
  font-weight: 700;
}

.dlp-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
}

.dlp-row {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 8px;
  background: #ffffff;
  cursor: pointer;
  box-sizing: border-box;
}

.dlp-row:hover {
  background: #f8fafc;
}

.dlp-row--selected {
  border-color: #2563eb;
  background: #eff6ff;
}

.dlp-row-top {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.dlp-name {
  flex: 1 1;
  min-width: 0;
  font-weight: 600;
  font-size: 13px;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dlp-meta {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

.dlp-row-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}

.dlp-bottom-left {
  flex-shrink: 0;
}

.dlp-badge {
  font-size: 10px;
  padding: 2px 5px;
  border-radius: 999px;
  border: 1px solid #d1d5db;
  background: #f8fafc;
  color: #475569;
  white-space: nowrap;
}

.dlp-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.dlp-check {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  color: #334155;
  white-space: nowrap;
}

.dlp-check input {
  width: 12px;
  height: 12px;
  margin: 0;
}

.dlp-action-btn {
  width: 24px;
  height: 24px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background: #ffffff;
  color: #111827;
  cursor: pointer;
  font-size: 13px;
  padding: 0;
}

.dlp-delete-btn {
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 6px;
  background: #dc2626;
  color: #ffffff;
  cursor: pointer;
  font-size: 16px;
  padding: 0;
}

.dlp-delete-btn:hover {
  background: #b91c1c;
}

.dlp-action-btn:hover {
  background: #eff6ff;
  border-color: #93c5fd;
}

.dlp-empty {
  margin: 0;
  color: #6b7280;
}`, "",{"version":3,"sources":["webpack://./src/components/designer/DesignerLayersPanel.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB","sourcesContent":[".dlp-panel {\n  border: 1px solid #d1d5db;\n  border-radius: 12px;\n  background: #ffffff;\n  padding: 12px;\n  max-height: 560px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.dlp-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.dlp-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.dlp-collapse-toggle {\n  width: 32px;\n  height: 32px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #111827;\n  cursor: pointer;\n}\n\n.dlp-collapse-toggle--collapsed {\n  width: 100%;\n  height: auto;\n  padding: 10px 12px;\n  font-weight: 700;\n}\n\n.dlp-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 4px;\n}\n\n.dlp-row {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 8px;\n  background: #ffffff;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.dlp-row:hover {\n  background: #f8fafc;\n}\n\n.dlp-row--selected {\n  border-color: #2563eb;\n  background: #eff6ff;\n}\n\n.dlp-row-top {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.dlp-name {\n  flex: 1;\n  min-width: 0;\n  font-weight: 600;\n  font-size: 13px;\n  color: #111827;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dlp-meta {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.dlp-row-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n}\n\n.dlp-bottom-left {\n  flex-shrink: 0;\n}\n\n.dlp-badge {\n  font-size: 10px;\n  padding: 2px 5px;\n  border-radius: 999px;\n  border: 1px solid #d1d5db;\n  background: #f8fafc;\n  color: #475569;\n  white-space: nowrap;\n}\n\n.dlp-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.dlp-check {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 10px;\n  color: #334155;\n  white-space: nowrap;\n}\n\n.dlp-check input {\n  width: 12px;\n  height: 12px;\n  margin: 0;\n}\n\n.dlp-action-btn {\n  width: 24px;\n  height: 24px;\n  border: 1px solid #cbd5e1;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #111827;\n  cursor: pointer;\n  font-size: 13px;\n  padding: 0;\n}\n\n.dlp-delete-btn {\n  width: 24px;\n  height: 24px;\n  border: none;\n  border-radius: 6px;\n  background: #dc2626;\n  color: #ffffff;\n  cursor: pointer;\n  font-size: 16px;\n  padding: 0;\n}\n\n.dlp-delete-btn:hover {\n  background: #b91c1c;\n}\n\n.dlp-action-btn:hover {\n  background: #eff6ff;\n  border-color: #93c5fd;\n}\n\n.dlp-empty {\n  margin: 0;\n  color: #6b7280;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
